import { createComponent } from '@helpers/admin';
import GridContainerComponent from '@template/blocks/GridContainer/component';

export const GridBox = createComponent({
  label: 'Grid Container',
  component: GridContainerComponent,
  fields: {
    gap: {
      label: 'Gap',
      type: 'number',
      default: 12,
    },
    justifyContent: {
      label: 'Justify Content',
      type: 'select',
      options: [
        {
          label: 'Start',
          value: 'flex-start',
        },
        {
          label: 'Center',
          value: 'center',
        },
        {
          label: 'End',
          value: 'flex-end',
        },
        {
          label: 'Space Between',
          value: 'space-between',
        },
        {
          label: 'Space Around',
          value: 'space-around',
        },
        {
          label: 'Space Evenly',
          value: 'space-evenly',
        },
      ],
    },
    alignItems: {
      label: 'Align Items',
      type: 'select',
      options: [
        {
          label: 'Start',
          value: 'flex-start',
        },
        {
          label: 'Center',
          value: 'center',
        },
        {
          label: 'End',
          value: 'flex-end',
        },
        {
          label: 'Stretch',
          value: 'stretch',
        },
      ],
    },
    columns: {
      label: 'Items',
      type: 'array',
      default_items: 2,
      arrayFields: {
        span: {
          label: 'Span',
          type: 'number',
          placeholder: '1-12',
          default: 6,
          min: 1,
          max: 12,
        },
      },
    },
    padding: {
      label: 'Padding',
      type: 'object',
      objectFields: {
        vertical: {
          label: 'Vertical',
          type: 'number',
        },
        horizontal: {
          label: 'Horizontal',
          type: 'number',
        },
      },
    },
    reverse: {
      label: 'Reverse Order',
      type: 'boolean',
    },
    autoMaxWidth: {
      label: 'Auto Max Width',
      type: 'boolean',
      default: true,
    },
  },
});
